import React, { useCallback } from 'react'
import { I18n, hooks } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Grid } from '@mui/material'

import Callbacks from './callbacks'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const UserList = props => {
  const [codeIntlPhone] = hooks.useSetting('code_international_phone')

  const filterToForm = useCallback(Callbacks.filterToFormHandler(codeIntlPhone), [codeIntlPhone])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(codeIntlPhone), [codeIntlPhone])

  return (
    <Box sx={{ p: 2 }}>
      <Grid container justifyContent='center' alignItems='center' sx={{ bgcolor: 'background.primary' }}>
        <Grid size={11}>
          <SearchFrame
            model_name={'user'}
            populate={[
              'customerinfo',
              'info',
              'auth'
            ]}
            createButtonProps={{
              label: I18n.t('user.add')
            }}
          >
            <SearchForm
              filterToForm={filterToForm}
              formToFilter={formToFilter}
              submitOnMount
            >
              <FormContent><Form /></FormContent>
            </SearchForm >
            <SearchTable>
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame >
        </Grid >
      </Grid >
    </Box >
  );
}

export default React.memo(UserList)
